function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

function capitalize(str) {
  if (!str) return '';

  return str.toString()
    .toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function truncate(value, _length, where) {
  if (!value) return '--';

  let length = _length;
  if (typeof length !== 'number') {
    length = Number.parseInt(length, 10) || 40;
  }

  const str = (value).toString();
  if (str.length <= length) {
    return str;
  }
  if (where === 'end') {
    return `...${str.slice(-1 * length)}`;
  }
  return str.slice(0, length).concat('...');
}

function truncateString(str, { maxChars, maxWords }) {
  if (typeof str === 'string') {
    if (maxChars) {
      const charCount = str.length;
      if (charCount > maxChars) {
        return str.substring(0, maxChars - 1).concat('…');
      }
    }
    if (maxWords) {
      const wordArray = str.split(/\s/);
      const wordCount = wordArray.length;
      if (maxWords && wordCount > maxWords) {
        return wordArray.slice(0, maxWords).join(' ').substring(0, maxChars - 1).concat('…');
      }
    }
  }
  return str;
}

module.exports = {
  camelize,
  capitalize: (str = null) => capitalize(str),
  escapeRegExp,
  json_stringify: (value) => JSON.stringify(value, null, 2),
  truncate: (value = '--', length = 40, where = 'start') => truncate(value, length, where),
  truncateString: (str, { maxChars, maxWords }) => truncateString(str, { maxChars, maxWords }),
};
